// extracted by mini-css-extract-plugin
export default {"linkList":"SideBar_linkList__Yia5E"};